import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CatalogoService } from '../../../services/catalogo.service'; 
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { LfsaBotonEditarGridComponent } from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { empModulo } from '../../../diccionarios/empModulo';
import { ResponseCsvEmpModel } from '../../../models/respnseCsvEmpModel';
import { CrearEmpleadoService } from '../../../services/administrador/crear-empleado.service';

@Component({
  selector: 'app-upload-empleado',
  templateUrl: './upload-empleado.component.html',
  styleUrls: ['./upload-empleado.component.css']
})
export class UploadEmpleadoComponent implements OnInit {

  mostrarFormulario = false;

  textoBuscar = '';
  gridApi: any;
  gridColumnApi: any;
  columnDefs: any[];
  rowData: ResponseCsvEmpModel[] = [];
  frameworkComponents: any;
  rowSelection: any;

  @ViewChild('fileInput') fileInput: ElementRef;
  formulario: FormGroup;
  loading:boolean = false;
  empModulo: any = {};
  listaVacia:boolean = true;

  DAT_BTNS: any;
  DAT_MSG: any;
  DAT_BTNCSS: any;
  cmbPlanta: any[] = [];
  cmbLinea: any;

  refineriaIcon: string;
  plantaIcon: string;
  csv: string;

  constructor(public fb: FormBuilder,
    private _util: UtilsService,
    private _upload: CrearEmpleadoService,
    private catalogo: CatalogoService,
    ) { }

  ngOnInit() {
    this.empModulo = empModulo;
    // this.DAT_BTNS = this.moduloTvc.button.buttonsNombre;
    // this.DAT_MSG = this.moduloTvc.mensajes;
    // this.DAT_BTNCSS = this.moduloTvc.button.buttonsCss;
    this.formulario = this.fb.group({
      multipart: ['', [Validators.required]],
    });
    this.cargarGrid();
    this.cargarIconosFiltros();
  }

  cargarGrid() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.columnDefs = [
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 120,
        cellRendererParams: {
          onClick: this.eliminarElemento.bind(this),
          label: 'Eliminar',//this.DAT_BTNS.eliminar,//buttons.eliminar,
          colorBoton: 'btn btn-danger'//'btn btn-danger btn btn-block'
        }
      },
      // {
      //   headerName: 'SEC',
      //   field: 'secuencial',
      //   sortable: true,
      //   filter: true,
      //   width: 120
      // },
      {
        headerName: 'CEDULA',
        field: 'cedula',
        sortable: true,
        filter: true,
        width: 160
      },
      {
        headerName: 'NOMBRE',
        field: 'nombres',
        sortable: true,
        filter: true,
        width: 320
      },
      {
        headerName: 'T.EMPLEADO',
        field: 'tipoEmleado',
        sortable: true,
        filter: true,
        width: 220
      },
      {
        headerName: 'ERRORES',
        field: 'errores',
        sortable: true,
        filter: true,
        width: 220
      },
      {
        headerName: 'ESTADO',
        field: 'estado',
        sortable: true,
        filter: true,
        width: 200,
        cellStyle: this.changeRowColor.bind(this),
        valueGetter: function(params){
          return (params.data.estado === true)?'CORRECTO':'INCORRECTO';
        }
      }
    ];
    this.rowSelection = 'multiple';
  }

  cargarIconosFiltros() {
    this.csv = this.catalogo.catalogoAsesorIcon().csv;
  }

  eliminarElemento({rowData}) {
    this._util.confirmarSincronoPromesaSinActions(
      {
        title: 'Esta seguro que desea eliminar el siguiente elemento?',
        text: '',
        action: 'Eliminar',
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      this.rowData = this.rowData.filter(item => item.secuencial !== rowData.secuencial);
    }).catch((err) => {
      console.log('Error ' + err);
      this._util.mensajeErrorVisto(err.error.message);
    });
  }

  changeRowColor(params) {
    let data = params.data;
    if (data.estado != undefined) {
      if (data.estado === true) {
        return {
          'background-color': 'lightgreen',
          'color': 'black',
          'font-weight': 'bold',
          'font-size': '14px'
        };
      } else {
        return {
          'background-color': '#FFC0CB',
          'color': 'black',
          'font-weight': 'bold',
          'font-size': '14px'
        };
      }
    }
    return false;
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  onQuickFilterChanged() {
    this.gridApi.setQuickFilter(this.textoBuscar);
  }

  onFileSelect(event) {
    let allowedExtensions = /(.csv)$/i;
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      if (!allowedExtensions.exec(file.name)) {
        this.formulario.get('multipart').setValue('');
        this._util.mensajeErrorVisto('El tipo de archivo no es valido, el tipo de archivo permitido es "CSV" ', true, 9000);
        this.fileInput.nativeElement.value = '';
      } else {
        this.formulario.get('multipart').setValue(file);
      }
    }
  }

  setFormData(data: any) {
    const formData = new FormData();
    formData.append('file', data.multipart);
    return formData;
  }

  enviarFormulario() {
    this._util.confirmarSincronoPromesaNormal(
      {
        title: 'Esta seguro que desea enviar el siguiente archivo?',
        text: '',
        action: 'Enviar',
        funcion: this._upload.uploadFile(this.setFormData(this.formulario.value)),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      // debugger
      this.mostrarFormulario = true;
      this.rowData = res;
      if(this.rowData.length > 0){
        this.listaVacia = false;
      } else {
        this.listaVacia = true;
      }
    }).catch((err) => {
      console.log('Error ' + err);
      this.rowData = [];
      this.listaVacia = true;
    });
  }

  async guardar() {
    let listErrors:any[] = [];
    this.rowData.forEach(async (e) => {
      if(e.estado === false){
        listErrors.push(e);
      }
    });
    if(listErrors.length > 0){
      this._util.mensajeErrorVisto('Hay elementos incorrectos en el envio de datos de colaboradores!!!', true, 10000);
      return;
    }
    await this._util.confirmarSincronoPromesaNormal(
      {
        title: 'Esta seguro que desea actualizar el siguiente listado de colaboradores?',
        text: '',
        action: 'Guardar',
        funcion: this._upload.updateType(this.rowData),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      this.regresar();
    }).catch((err) => {
      console.log('Error ' + err);
      this._util.mensajeErrorVisto(err.error.message, true, 3000);
    });
  }

  regresar() {
    this.mostrarFormulario = false;
    this.rowData = [];
    this.formulario.reset();
  }

}
